import './index.css'

const Categories = props => {
  const {tabsList, onClickCatogory, activeTabId} = props
  const {tabId, displayText} = tabsList
  const onCategory = () => {
    onClickCatogory(tabId)
  }
  const btnClass = activeTabId === tabId ? 'activeCategoryBtn' : 'categoryBtn'
  return (
    <li className="liContainer">
      <button type="button" className={btnClass} onClick={onCategory}>
        {displayText}
      </button>
    </li>
  )
}
export default Categories
